export default "__VITE_ASSET__C90ooFtR__"